import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Candidates } from '../../models/candidates.model';
import { UsersService } from '../../services/users.service';
import { FunctionsService } from '../../services/functions.service';
import { HttpService } from '../../services/http.service';
import { Trainings } from '../../models/trainings.model';
import { Professions } from 'src/app/models/professions.model';
import { CandidatesProfiles } from '../../models/candidatesProfiles.model';
import { CandidatesExperiences } from 'src/app/models/candidatesExperiences.model';
import { AreaActivities } from '../../models/areaActivities.model';
import { CandidatesTrainings } from '../../models/candidatesTrainings.model';
import { CandidatesLanguages } from '../../models/candidatesLanguages.model';
import { Languages } from 'src/app/models/languages.model';
import { CandidatesSkills } from '../../models/candidatesSkills.model';
import { Skills } from '../../models/skills.model';
import { CandidatesCertificates } from 'src/app/models/candidatesCertificates.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-candidat-profile-recrutement',
  templateUrl: './candidat-profile-recrutement.component.html',
  styleUrls: ['./candidat-profile-recrutement.component.scss']
})
export class CandidatProfileRecrutementComponent implements OnInit {
  @Input() typeInterface: string = 'candidat';
  personalInfoIsLoading: boolean = false;
  profileIsLoading: boolean = false;
  experienceIsLoading: boolean = false;
  trainingIsLoading: boolean = false;
  languageIsLoading: boolean = false;
  skillIsLoading: boolean = false;
  certificatIsLoading: boolean = false;
  personalInfoForm: FormGroup = new FormGroup({});
  profilesForm: FormGroup = new FormGroup({});
  experiencesForm: FormGroup = new FormGroup({});
  trainingsForm: FormGroup = new FormGroup({});
  languagesForm: FormGroup = new FormGroup({});
  skillsForm: FormGroup = new FormGroup({});
  certificatsForm: FormGroup = new FormGroup({});
  candidates: Candidates = new Candidates([]);
  candidatesProfiles: CandidatesProfiles = new CandidatesProfiles({});
  candidatesExperiences: CandidatesExperiences = new CandidatesExperiences({});
  candidatesTrainings: CandidatesTrainings = new CandidatesTrainings({});
  candidatesLanguages: CandidatesLanguages = new CandidatesLanguages({});
  candidatesSkills: CandidatesSkills = new CandidatesSkills({});
  candidatesCertificates: CandidatesCertificates = new CandidatesCertificates({});
  tempWorkerValue: any;
  driverLicenceValue: any;
  passportValue: any;
  experienceProValue: any
  cvValue: any;
  cvFile: any;
  cvPath: any;
  idcardValue: any;
  idcardFile: any;
  idCard: any;
  countryData: any;
  countryList: any[] = [];
  cityList: any[] = [];
  trainingList: Trainings[] = [];
  professionList: Professions[] = [];
  areaActivityList: AreaActivities[] = [];
  attestationFile: any = null;
  experienceList: CandidatesExperiences[] = [];
  languageList: Languages[] = [];
  skillList: Skills[] = [];
  diplomaFile: any = null;
  certificatFile: any = null;
  candidateProfileList: CandidatesProfiles[] = [];
  candidateTrainingList: CandidatesTrainings[] = [];
  candidateLanguageList: CandidatesLanguages[] = [];
  candidateSkillList: CandidatesSkills[] = [];
  candidateCertificateList: CandidatesCertificates[] = [];
  dateObj = new Date();
  currentMonth = (this.dateObj.getUTCMonth() + 1 < 10) ? '0' + (this.dateObj.getUTCMonth() + 1) : this.dateObj.getUTCMonth() + 1;
  currentYear = this.dateObj.getUTCFullYear();
  totalFillingRate = 0;
  personalInfoRate = 0;
  profileRate = 0;
  experienceRate = 0;
  trainingRate = 0;
  languageRate = 0;
  skillRate = 0;
  showBtnToGoApplyJob = false;
  jobIDToApply: any;
  step: any = 1;

  constructor(private router: Router, private formBuilder: FormBuilder, private usersService: UsersService, public functionsService: FunctionsService, private httpService: HttpService) {


    if (usersService.getUserType() != 'candidat') {
      this.router.navigate(['/not-found']);
    }

    this.candidates = this.usersService.getCurrentUser();
    this.trainingList = this.functionsService.getTrainingsList();
    this.professionList = this.functionsService.getProfessionsList();

    if (localStorage.getItem('jobIDToApply') && localStorage.getItem('jobIDToApply') != undefined) {
      this.jobIDToApply = localStorage.getItem("jobIDToApply");

      this.showBtnToGoApplyJob = true;
    }
  }


  ngOnInit(): void {
    this.totalFillingRate;
    this.calculateTotalFillingRate();
    this.initProfileForm();

  }


  calculateTotalFillingRate() {

    if (this.candidates.getGender() !== null && this.candidates.getGender() !== '') {
      this.personalInfoRate = 20;
    } else {
      this.personalInfoRate = 0;
    }

    if (this.candidatesProfiles.getProfessions() && this.candidatesProfiles.getProfessions().getLibelle() != undefined) {
      this.profileRate = 20;
    } else {
      this.profileRate = 0;
    }

    if (this.candidates.getCandidatesTrainings().length > 0) {
      this.trainingRate = 15;
    } else {
      this.trainingRate = 0;
    }

    if (this.candidates.getCandidatesLanguages().length > 0) {
      this.languageRate = 15;
    } else {
      this.languageRate = 0;
    }

    if (this.candidates.getCandidatesSkills().length > 0) {
      this.skillRate = 15;
    } else {
      this.skillRate = 0;
    }

    if (this.candidates.getCandidatesExperiences().length > 0) {
      this.experienceRate = 15;
    } else {
      this.experienceRate = 0;
    }

    this.totalFillingRate = this.personalInfoRate + this.profileRate + this.experienceRate + this.trainingRate + this.languageRate + this.skillRate;

    localStorage.setItem('totalFillingRate', JSON.stringify(this.totalFillingRate));
  }

  initProfileForm() {
    this.calculateTotalFillingRate();
    this.getCandidateProfiles();
    this.professionList = this.functionsService.getProfessionsList();

    // let professions = (this.candidatesProfiles.getProfessions() != undefined) ? new Professions(this.candidatesProfiles.getProfessions()) : new Professions({});
    // let trainings = (this.candidatesProfiles.getTrainings() != undefined) ? new Trainings(this.candidatesProfiles.getTrainings()) : new Trainings({});
    this.profilesForm = this.formBuilder.group({
      profession_id: ['1', Validators.required],
      years_of_experience: ['2 à 5ans', Validators.required],
      position_level: ['Jeune diplomé', Validators.required],
      level_of_study: ['Secondaire', [Validators.required]],
      training_id: ['1', Validators.required],
      availability: ['Immédiate'],
      mobility: ['Régionale'],
      status: ['Sans emploi'],
      current_salary: ['400 à 500K'],
      desired_salary: ['400 à 500K'],
    });

    // if (professions.getId() != undefined && professions.getId() != null) {
    //   this.profileRate = 20;
    // }
  }

  onSubmitProfileForm(): any {
    let formValue: any = this.profilesForm.value;
    this.profileIsLoading = true;
    console.log(formValue);

    this.httpService.createProfile(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.profileIsLoading = false;
          this.initProfileForm();
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Votre profile a été mise à jour.',
          })
          this.candidates = this.usersService.getCurrentUser();
          this.initProfileForm();
          this.getCandidateProfiles();
        }
      },
      (error) => {
        console.log(error);
        this.profileIsLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }
  getCandidateProfiles() {

    const candidateProfile: any = this.candidates.getCandidatesProfiles();

    // console.log(candidateProfile);

    this.candidateProfileList = [];

    candidateProfile.forEach((element: any) => {
      let candidatesProfiles = new CandidatesProfiles(element);
      this.candidateProfileList.push(candidatesProfiles);
    });
    return this.candidateProfileList;
  }

}
